import { formatDateHuman, parseDateRaw } from "../date-utils";
export const materialStockDtoFields = [{
        name: "clfMaterialType",
        title: "Materiale",
        render: (record) => record.clfMaterialType.description
    }, {
        name: "lotNumber",
        title: "Lotto",
        render: (record) => record.materialStock.lotNumber
    }, {
        name: "quantity",
        title: "Quantità",
        render: (record) => record.materialStock.quantity
    }, {
        name: "roomType",
        title: "Stoccaggio",
        render: (record) => record.roomTypeName
    }, {
        name: "supplierName",
        title: "Fornitore",
        render: (record) => record.supplierName
    }, {
        name: "validFromDate",
        title: "Inizio Validità",
        render: (record) => formatDateHuman(parseDateRaw(record.materialStock.validFromDate))
    }, {
        name: "validUptoDate",
        title: "Fine Validità",
        render: (record) => !!record.materialStock.validUptoDate ? formatDateHuman(parseDateRaw(record.materialStock.validUptoDate)) : ""
    }];
